import firebaseApp from '../firebase';

const storage = firebaseApp.storage().ref();

export const getUrls = (paths) => {
  paths.urls = {};
  return storage.child(paths.orig).getDownloadURL()
  .then(url=>{
    paths.urls['orig'] = url;
    return storage.child(paths.scaled).getDownloadURL()
    .then(url => {
      paths.urls['scaled'] = url;
      return storage.child(paths.thumb).getDownloadURL()
      .then(url => {
        paths.urls['thumb'] = url;
        return paths;
      })
    })
  })
}

export const checkIfUrlExists = (url) => {
  try {
    let ref = firebaseApp.storage().refFromURL(url);
    return true;
  } catch (error) {
    console.log('Catch Error');
    if (url === '') {
      console.log('Not Found Blank: ' + url);
      return false;
    }

    var request;
    if(window.XMLHttpRequest) {
      request = new XMLHttpRequest();
    } else {
      request = new ActiveXObject("Microsoft.XMLHTTP");
    }
    
    
    request.open('GET', url, false);
    request.send(); // there will be a 'pause' here until the response to come.
    // the object request will be actually modified
    if (request.status === 404) {
      console.log('Not Found: ' + url);
      return false;
    }
    console.log('Found: ' + url);
    return true;
  }
  
}

export const deleteImage = (img) => {
  Object.keys(img).forEach(i => {
    if(checkIfUrlExists(img[i])) {
      let ref = firebaseApp.storage().refFromURL(img[i]);
      console.log(ref);
      ref.delete().catch(e => {
        console.log(e);
      });
    }
  });
}



// WEBPACK FOOTER //
// ./src/actions/images.js